import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=75b26cde&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=ts&"
export * from "./detail.vue?vue&type=script&lang=ts&"
import style0 from "./detail.vue?vue&type=style&index=0&id=75b26cde&prod&lang=less&scoped=true&"
import style1 from "./detail.vue?vue&type=style&index=1&id=75b26cde&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b26cde",
  null
  
)

export default component.exports